import { render, staticRenderFns } from "./StyleDemo.vue?vue&type=template&id=5413b389&lang=pug&"
import script from "./StyleDemo.vue?vue&type=script&lang=js&"
export * from "./StyleDemo.vue?vue&type=script&lang=js&"
import style0 from "./StyleDemo.vue?vue&type=style&index=0&id=5413b389&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports